import React, { memo } from "react";

import { classNames } from "helpers";
import { WAREHOUSE_WEEK_DAYS } from "services/api/fleet/warehouses/consts";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { WAREHOUSE_INTRO_SAMPLE } from "../consts";
import { WarehouseSceneProps } from "../types";

/** Korak "Radno vrijeme": tjedni raspored skladišta, danas otvoreno i prijem u radno vrijeme. */
const WarehouseWorkingHoursScene: React.FC<WarehouseSceneProps> = ({ formValues }) => {
  const openDays = formValues.workingHours.filter((day) => day.isOpen);
  const firstOpenDay = openDays[0];

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Radno vrijeme</div>
          <div className="text-sm font-bold text-slate-800 truncate">{formValues.name || WAREHOUSE_INTRO_SAMPLE.name}</div>
          <div className="mt-3 space-y-1">
            {WAREHOUSE_WEEK_DAYS.map(({ day, short }) => {
              const workingDay = formValues.workingHours.find((workingDay) => workingDay.day === day);
              const isOpen = !!workingDay?.isOpen;

              return (
                <div
                  key={day}
                  className={classNames(
                    "flex items-center justify-between rounded-sm px-2 py-1 text-[0.65rem]",
                    isOpen ? "bg-slate-50" : ""
                  )}
                >
                  <span className={isOpen ? "font-semibold text-slate-700" : "text-slate-400"}>{short}</span>
                  <span className={isOpen ? "text-slate-600" : "text-slate-400"}>
                    {isOpen ? `${workingDay?.from} do ${workingDay?.to}` : "Zatvoreno"}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 motion-safe:animate-pulse" />
            <span className="text-xs font-bold text-slate-800">Sada otvoreno</span>
          </div>
          <div className="mt-1 text-[0.65rem] text-slate-400">
            {firstOpenDay ? `Radi do ${firstOpenDay.to}` : "Upišite radno vrijeme"}
          </div>
          <div className="mt-3 text-[0.65rem] text-slate-500">
            Radnih dana u tjednu: <span className="font-semibold text-slate-700">{openDays.length}</span>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Preuzimanje u radno vrijeme"
          subtitle="Svi znaju kada je skladište otvoreno"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7v5l3 2" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(WarehouseWorkingHoursScene);
